<app-header></app-header>

<!-- Middle Content CSS End Here  -->
<div class="middle-content-wrap">
    <!-- Dashboard HTML Start Here  -->
    <div class="globalheading dflex dflex_bet">
        <h2>
            VIP Diner Management
        </h2>
        <div class="addbtnhead">
            <div class="page-header-right">
                <div class="common_btn">
                    <button class="add-user-btn" (click)="onAddVipDinerClick()" *ngIf="!isManager">
                        <img src="assets/images/plus.svg" alt=""> Add VIP Diner
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Dashboard HTML End Here  -->
    <div class="listingformat">
        <div class="tabledatawrap table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Venue Name</th>
                        <th>Address</th>
                        <th>Neighborhood</th>
                        <th>Date</th>
                        <th>Start Time</th>
                        <th>Image</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="
                    let item of vipDinerList | paginate: {id: 'vipDiners', itemsPerPage: total, currentPage: p , totalItems: count}; let i = index;">
                        <td class="width10">
                            {{ item.id }}
                        </td>
                        <td class="width15">
                            {{ item.venue_name }}
                        </td>
                        <td class="width20">
                            {{ item.address }}
                        </td>
                        <td class="width15">
                            {{ item.neighborhood }}
                        </td>
                        <td class="width15">
                            {{ item.date | date:'MMM dd, yyyy' }}
                        </td>
                        <td class="width15">
                            {{ item.start_time }}
                        </td>
                        <td class="width10">
                            <img *ngIf="item.image" class='table-image-width' [src]="item.image" alt="Venue Image" />
                            <span *ngIf="!item.image">No Image</span>
                        </td>
                        <td class="width15">
                            <div class="action-btns hide-profile-btn">
                                <button (click)="onView(item.id)" data-placement="top" title="View">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </button>
                                <button (click)="onEdit(item.id)" data-placement="top" title="Edit">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                </button>
                                <button (click)="onDelete(item.id)" data-placement="top" title="Delete">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="vipDinerList?.length==0">
                    <tr>
                        <td colspan="8">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 custompagination">
                <pagination-controls class="" previousLabel="Prev" nextLabel="Next" id="vipDiners"
                    (pageChange)="onTableDataChange($event)">
                </pagination-controls>
            </div>
        </div>
    </div>
    <!-- Dashboard HTML End Here  -->
</div>
<!-- Middle Content CSS End Here  -->

<!-- Add VIP Diner Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="addVipDinerModal" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Add VIP Diner Reservation
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <form [formGroup]="vipDinerForm" (ngSubmit)="onSubmit()">
                        <div class="faq-wrap">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Venue Name <span>*</span></label>
                                            <span>
                                                <input name="venue_name" formControlName="venue_name" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="text" autocomplete="off" placeholder="Venue Name">
                                                <div class="errorDiv" *ngIf="shouldShowError('venue_name')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['venue_name'].errors?.['required']">
                                                        Venue name is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Address <span>*</span></label>
                                            <span>
                                                <textarea name="address" formControlName="address" rows="3"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    autocomplete="off" placeholder="Enter address" required></textarea>
                                                <div class="errorDiv" *ngIf="shouldShowError('address')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['address'].errors?.['required']">
                                                        Address is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Neighborhood</label>
                                            <span>
                                                <input name="neighborhood" formControlName="neighborhood" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="text" autocomplete="off" placeholder="Neighborhood">
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Date <span>*</span></label>
                                            <span>
                                                <input name="date" formControlName="date" size="40" class="form-control"
                                                    aria-required="true" aria-invalid="false" type="date"
                                                    autocomplete="off" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('date')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['date'].errors?.['required']">
                                                        Date is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Start Time <span>*</span></label>
                                            <span>
                                                <input name="start_time" formControlName="start_time" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="time" autocomplete="off" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('start_time')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['start_time'].errors?.['required']">
                                                        Start time is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Venue Image</label>
                                            <span>
                                                <input #photoInput id="photoInput" name="image" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="file" autocomplete="off" (change)="onFileSelected($event)"
                                                    accept="image/*" />
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Search Location</label>
                                            <span>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" id="locationSearch"
                                                        placeholder="Search for a location (e.g., 'Eiffel Tower, Paris')">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            (click)="searchLocation()">
                                                            <i class="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="map-container mb-3" style="height: 300px;">
                                        <div id="vipDinerMap" style="height: 100%;"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Latitude <span>*</span></label>
                                            <span>
                                                <input name="latitude" formControlName="latitude" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="number" autocomplete="off"
                                                    placeholder="Click on map to get latitude" step="any" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('latitude')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['latitude'].errors?.['required']">
                                                        Latitude is required
                                                    </div>
                                                    <div class="error"
                                                        *ngIf="f['latitude'].errors?.['min'] || f['latitude'].errors?.['max']">
                                                        Latitude must be between -90 and 90
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Longitude <span>*</span></label>
                                            <span>
                                                <input name="longitude" formControlName="longitude" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="number" autocomplete="off"
                                                    placeholder="Click on map to get longitude" step="any" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('longitude')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['longitude'].errors?.['required']">
                                                        Longitude is required
                                                    </div>
                                                    <div class="error"
                                                        *ngIf="f['longitude'].errors?.['min'] || f['longitude'].errors?.['max']">
                                                        Longitude must be between -180 and 180
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="common_btn">
                            <button type="button" data-dismiss="modal">Cancel</button>
                            <button type="submit" [disabled]="isSubmitting">
                                {{ isSubmitting ? 'Creating...' : 'Create' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- View VIP Diner Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="viewVipDinerModal" role="dialog"
    aria-labelledby="viewModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    VIP Diner Reservation Details
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard" *ngIf="selectedVipDiner">
                    <div class="faq-wrap">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>ID:</strong></label>
                                        <span>{{ selectedVipDiner.id }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Status:</strong></label>
                                        <span [class]="selectedVipDiner?.status?.toLowerCase()">{{
                                            selectedVipDiner.status || "NA" }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Venue Name:</strong></label>
                                        <span>{{ selectedVipDiner.venue_name }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Address:</strong></label>
                                        <span>{{ selectedVipDiner.address }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Date:</strong></label>
                                        <span>{{ selectedVipDiner.date | date:'MMM dd, yyyy' }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Start Time:</strong></label>
                                        <span>{{ selectedVipDiner.start_time }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Latitude:</strong></label>
                                        <span>{{ selectedVipDiner.latitude }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group full-input-wrap">
                                    <p>
                                        <label><strong>Longitude:</strong></label>
                                        <span>{{ selectedVipDiner.longitude }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="selectedVipDiner.image">
                            <div class="col-md-12">
                                <div class="form-group full-input-wrap">
                                    <label><strong>Image:</strong></label>
                                    <div class="mt-2">
                                        <img [src]="selectedVipDiner.image" alt="Venue Image"
                                            style="max-width: 100%; max-height: 300px; object-fit: cover;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="common_btn">
                        <button type="button" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Edit VIP Diner Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="editVipDinerModal" role="dialog"
    aria-labelledby="editModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Edit VIP Diner Reservation
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <form [formGroup]="vipDinerForm" (ngSubmit)="onUpdateSubmit()">
                        <div class="faq-wrap">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Venue Name <span>*</span></label>
                                            <span>
                                                <input name="venue_name" formControlName="venue_name" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="text" autocomplete="off" placeholder="Venue Name">
                                                <div class="errorDiv" *ngIf="shouldShowError('venue_name')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['venue_name'].errors?.['required']">
                                                        Venue name is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Address <span>*</span></label>
                                            <span>
                                                <textarea name="address" formControlName="address" rows="3"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    autocomplete="off" placeholder="Enter address" required></textarea>
                                                <div class="errorDiv" *ngIf="shouldShowError('address')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['address'].errors?.['required']">
                                                        Address is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Neighborhood</label>
                                            <span>
                                                <input name="neighborhood" formControlName="neighborhood" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="text" autocomplete="off" placeholder="Neighborhood">
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Date <span>*</span></label>
                                            <span>
                                                <input name="date" formControlName="date" size="40" class="form-control"
                                                    aria-required="true" aria-invalid="false" type="date"
                                                    autocomplete="off" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('date')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['date'].errors?.['required']">
                                                        Date is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Start Time <span>*</span></label>
                                            <span>
                                                <input name="start_time" formControlName="start_time" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="time" autocomplete="off" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('start_time')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['start_time'].errors?.['required']">
                                                        Start time is required
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Venue Image</label>
                                            <span>
                                                <input #editPhotoInput id="editPhotoInput" name="image" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="file" autocomplete="off" (change)="onFileSelected($event)"
                                                    accept="image/*" />
                                                <div *ngIf="existingImageUrl" class="mt-2">
                                                    <img [src]="existingImageUrl" alt="Current Venue Image"
                                                        style="max-width: 200px; max-height: 150px; object-fit: cover;" />
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Search Location</label>
                                            <span>
                                                <div class="input-group">
                                                    <input type="text" class="form-control" id="editLocationSearch"
                                                        placeholder="Search for a location (e.g., 'Eiffel Tower, Paris')">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button"
                                                            (click)="searchLocation()">
                                                            <i class="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="map-container mb-3" style="height: 300px;">
                                        <div id="editVipDinerMap" style="height: 100%;"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Latitude <span>*</span></label>
                                            <span>
                                                <input name="latitude" formControlName="latitude" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="number" autocomplete="off"
                                                    placeholder="Click on map to get latitude" step="any" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('latitude')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['latitude'].errors?.['required']">
                                                        Latitude is required
                                                    </div>
                                                    <div class="error"
                                                        *ngIf="f['latitude'].errors?.['min'] || f['latitude'].errors?.['max']">
                                                        Latitude must be between -90 and 90
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group full-input-wrap">
                                        <p>
                                            <label>Longitude <span>*</span></label>
                                            <span>
                                                <input name="longitude" formControlName="longitude" size="40"
                                                    class="form-control" aria-required="true" aria-invalid="false"
                                                    type="number" autocomplete="off"
                                                    placeholder="Click on map to get longitude" step="any" required>
                                                <div class="errorDiv" *ngIf="shouldShowError('longitude')"
                                                    class="invalid-feedback">
                                                    <div class="error" *ngIf="f['longitude'].errors?.['required']">
                                                        Longitude is required
                                                    </div>
                                                    <div class="error"
                                                        *ngIf="f['longitude'].errors?.['min'] || f['longitude'].errors?.['max']">
                                                        Longitude must be between -180 and 180
                                                    </div>
                                                </div>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="common_btn">
                            <button type="button" data-dismiss="modal">Cancel</button>
                            <button type="submit" [disabled]="isSubmitting">
                                {{ isSubmitting ? 'Updating...' : 'Update' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>